import React, { Fragment } from "react";
import NotesList from "./NotesList";

const NotesBody = () => {
  return (
    <Fragment>
      <NotesList />
    </Fragment>
  );
};

export default NotesBody;
